<template>
    <v-container class="fill-height" fluid>
        <!-- Etichetta staging posizionata in alto a destra -->
        <v-chip
            v-if="isStaging"
            color="warning"
            text-color="white"
            small
            class="staging-badge"
        >
            STAGING
        </v-chip>
        <!-- Badge development -->
        <v-chip
            v-if="isDev"
            color="red"
            text-color="white"
            small
            class="staging-badge"
        >
            DEVELOPMENT
        </v-chip>
        
        <v-slide-y-transition mode="out-in">
            <v-row align="center" justify="center" v-show="ready">
                <v-col cols="12" sm="10" md="6" lg="4" xl="4" class="text-center">
                    <img :src="logo" style="width: 350px" alt="GiveMeHive!" class="pb-4">
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-show="fqdnShow"
                        v-model="fqdn"
                        label="Cliente"
                        type="text"
                        prepend-icon="business"
                        ref="fqdn"
                        :error-messages="errors.collect('Cliente')"
                        v-validate="'required'"
                        data-vv-name="Cliente"
                        @keyup.enter="submit"
                        @change="getTenantInfo"
                    ></v-text-field>

                    <v-progress-circular v-if="!ssoLoaded" indeterminate color="primary" size="32" class="my-4"></v-progress-circular>

                    <v-alert v-if="ssoSenzaProvider" type="error" text class="text-left">
                        Accesso non disponibile: nessun metodo di accesso e' configurato per questo gestionale. Contatta l'amministratore.
                    </v-alert>

                    <!-- Porta di servizio: con l'obbligo SSO attivo il form password resta
                         raggiungibile solo da qui. Il backend continua a rifiutare le
                         credenziali normali del tenant (vedi sso_required in LoginAPIController):
                         questo link non indebolisce nulla, lascia solo passare il master login. -->
                    <div v-if="ssoRequired && !forzaPassword" class="text-center text-caption mt-2 mb-4">
                        <a href="#" @click.prevent="mostraFormPassword">Accedi con password</a>
                    </div>

                    <template v-if="showPasswordForm">
                    <v-text-field
                        v-model="email"
                        label="Email"
                        type="email"
                        prepend-icon="person"
                        ref="email"
                        :error-messages="errors.collect('Email')"
                        v-validate="'required|email'"
                        data-vv-name="Email"
                        @keyup.enter="submit"
                    ></v-text-field>
                    <v-text-field
                        v-model="password"
                        label="Password"
                        type="password"
                        prepend-icon="lock"
                        :error-messages="errors.collect('Password')"
                        v-validate="'required'"
                        data-vv-name="Password"
                        @keyup.enter="submit"
                    ></v-text-field>
                    </template>

                    <template v-if="showPasswordForm">
                    <template v-if="insertOTP">
                        <div class="ma-auto position-relative" style="max-width: 300px">
                            <v-otp-input
                                length="6"
                                type="number"
                                v-model="otp"
                                ref="otp"
                                v-validate="'required|length:6'"
                                data-vv-name="otp"
                                :error-messages="errors.collect('otp')"
                                @finish="submit"
                            ></v-otp-input>
                        </div>
                        <v-row class="ma-0" align="center">
                            <v-subheader class="px-0 py-8 ma-auto">Inserisci OTP</v-subheader>
                        </v-row>
                    </template>
                    <template v-else-if="twofaqrcode">
                        <v-alert class="background-2 round-card">
                            <v-row align="center">
                                <v-col class="grow">
                                    <v-list-item-title>Autenticatione a 2 fattori</v-list-item-title>
                                    <v-subheader class="px-0" style="display: inline">Attiva l'autenticazione a 2 fattori e rendi GiveMeHive un posto più sicuro</v-subheader>
                                </v-col>
                            </v-row>
                        </v-alert>
                        <v-card class="flex pa-0 mb-2 round-card background-2" v-if="twofaqrcode">
                            <v-card-text>
                                <v-img
                                    :src="twofaqrcode"
                                    width="250"
                                    class="ma-auto round-card"
                                ></v-img>	
                                <v-row class="ma-0" align="center">
                                    <p class="px-0 py-8 ma-auto">Scansiona questo QR code con un'app di autenticazione a due fattori</p>
                                </v-row>
                                <v-row class="ma-0" align="center">
                                    <p class="px-0 pb-8 ma-auto">Secret Key: {{ google2fa_secret }}
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">											
                                                <v-btn v-bind="attrs" v-on="on" class="mx-6"
                                                    icon
                                                    small
                                                    @click.native.stop="getCopy()">
                                                    <v-icon color="primary">mdi-content-copy</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Copia</span>
                                        </v-tooltip>
                                    </p>
                                </v-row>
                                <div class="ma-auto position-relative" style="max-width: 300px">
                                    <v-otp-input
                                        length="6"
                                        type="number"
                                        v-model="otp"
                                        ref="otp"
                                        v-validate="'required|length:6'"
                                        data-vv-name="otp"
                                        :error-messages="errors.collect('otp')"
                                        @finish="submit"
                                    ></v-otp-input>
                                </div>
                            </v-card-text>
                        </v-card>
                    </template>
                    </template>

                    <template v-if="showPasswordForm">
                    <v-row class="pt-2" :class="{'pb-16': !ssoProviders.length}" align="center" justify="center" >
                        <v-col cols="12" class="text-center">
                            <v-btn
                                large
                                rounded
                                color="primary"
                                ripple
                                :loading="loadingLogin"
                                @click="submit"
                                class="w100p">
                                Accedi
                            </v-btn>
                        </v-col>
                    </v-row>
                    </template>

                    <!-- I provider vanno dopo il pulsante Accedi: messi sopra, subito
                         sotto email e password, sembrano il modo per inviare quei campi. -->
                    <div v-if="ssoProviders.length" class="pb-16">
                        <div v-if="showPasswordForm" class="d-flex align-center my-4">
                            <v-divider></v-divider>
                            <span class="px-3 text-caption">oppure</span>
                            <v-divider></v-divider>
                        </div>

                        <v-btn
                            v-for="provider in ssoProviders"
                            :key="provider.value"
                            block
                            outlined
                            color="primary"
                            class="mb-2"
                            @click="avviaSso(provider.value)"
                        >
                            <v-icon left small>{{ iconaProvider(provider.value) }}</v-icon>
                            Accedi con {{ provider.text }}
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-slide-y-transition>
    </v-container>
</template>

<script>
    export default {
        name: 'login',
        data: () => ({
            fqdnShow: true,
            fqdn: '',
            email: '',
            password: '',
            logo: 'img/logo_gmh.svg',
            ready: false,
            loadingLogin: false,
            // tfa
            insertOTP: false,
            otp: '',
            twofaqrcode: '',
            google2fa_secret: '',
            isStaging: process.env.VUE_APP_STAGING == 'true' || window.location.hostname.includes('staging'),
            isDev: process.env.NODE_ENV == 'development',
            ssoProviders: [],
            ssoRequired: false,
            ssoLoaded: false,
            // M7: porta di servizio del master login quando l'obbligo SSO e'
            // attivo. Il form resta nascosto finche' non viene aperto
            // esplicitamente dal link "Accedi con password".
            forzaPassword: false,
        }),

        computed: {
            // Il form password resta nascosto finche' non sappiamo se
            // questo tenant obbliga l'SSO (mostrarlo in anticipo aprirebbe
            // una finestra in cui sarebbe comunque cliccabile), oppure se
            // l'obbligo c'e' ma l'utente ha scelto esplicitamente la porta
            // di servizio.
            showPasswordForm() {
                return this.ssoLoaded && (!this.ssoRequired || this.forzaPassword)
            },
            // Tenant configurato con SSO obbligatorio ma senza nessun
            // provider disponibile: nessuna via di accesso, meglio dirlo
            // esplicitamente che mostrare una schermata vuota.
            ssoSenzaProvider() {
                return this.ssoLoaded && this.ssoRequired && !this.ssoProviders.length
            },
        },

        methods: {

            submit() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }
                    this.loadingLogin = true

                    const { fqdn, email, password } = this
                    localStorage.setItem('fqdn', fqdn)
                    this.$store.dispatch('SET_FQDN')
                    let data = { email, password }

                    if(this.otp && this.otp.length == 6) {
                        data.otp = this.otp
                    }
                    
                    this.$store.dispatch('AUTH_REQUEST', data).then((data) => {
                        // if 2fa is not enabled
                        if(data.success == true) {
                            this.$router.replace('/')
                        // if 2fa is enabled and otp must be inserted
                        } else if(data.data == 'insert_otp') {
                            this.insertOTP = true
                            setTimeout(() => {
                                this.$refs.otp.focus()
                            }, 200)
                        // if 2fa is enabled and must be activated for the first time
                        } else if(data.data.qrcode) {
                            this.insertOTP = false
                            this.twofaqrcode = data.data.qrcode
                            this.google2fa_secret = data.data.google2fa_secret
                            setTimeout(() => {
                                this.$refs.otp.focus()
                            }, 200)
                        }
                        this.loadingLogin = false
                        
                    }, (err) => {
                        this.otp = ''
                        this.loadingLogin = false
                        // Gli errori con risposta HTTP hanno gia' il messaggio
                        // dell'interceptor (credenziali errate, permesso negato,
                        // e anche il rifiuto per obbligo SSO che e' un 403 con
                        // messaggio): qui si copre solo chi non ne produce
                        // nessuno, che altrimenti lascerebbe la form muta.
                        if(!err || !err.response) {
                            this.$store.commit('setSnackbar', {
                                timeout: 6000,
                                text: err && err.message == 'Network Error'
                                    ? 'Nessuna connessione: controlla la rete e riprova.'
                                    : 'Accesso non riuscito. Riprova; se il problema persiste contatta l\'assistenza.',
                                value: true,
                                color: 'error'
                            })
                        }
                    })
                }).catch(() => {

                })
            },

            setLogo() {
                if(localStorage.hasOwnProperty('app_logo')) {
                    this.logo = localStorage.app_logo
                } else if(this.$vuetify.theme.dark) {
                    this.logo = 'img/logo_gmh_bianco.svg'
                } else {
                    this.logo = 'img/logo_gmh.svg'
                }

                if(localStorage.hasOwnProperty('app_color')) {
                    this.$vuetify.theme.themes.light.primary = this.$vuetify.theme.themes.dark.primary = localStorage.app_color
                } else {
                    this.$vuetify.theme.themes.light.primary = this.$vuetify.theme.themes.dark.primary = '#FFC107'
                }

                // Aggiorna il colore della StatusBar usando Capacitor
                if (this.$capacitor && this.$capacitor.isNative) {
                    this.$capacitor.setStatusBarColor(this.$vuetify.theme.themes.light.primary)
                }

                this.init()
            },

            init() {
                this.$store.commit('endProgress')

                if(localStorage.hasOwnProperty('fqdn')) {
                    this.fqdn = localStorage.getItem('fqdn')
                    // Il campo email compare solo a configurazione SSO nota
                    // (v-if="showPasswordForm"): il ref potrebbe non esistere
                    // ancora a questo punto.
                    if (this.$refs.email) {
                        this.$refs.email.focus()
                    }
                } else {
                    this.$refs.fqdn.focus()
                }

                // La baseURL di axios punta gia' al tenant giusto a questo punto
                // (SET_FQDN e' gia' stato dispatchato, sia al boot che in getTenantInfo)
                this.caricaConfigurazioneSso()

                this.ready = true
            },

            applicaConfigurazioneSso(data) {
                // L'elenco dei provider lo dichiara il backend: nessuna lista
                // cablata qui, cosi' Microsoft compare da solo quando le
                // credenziali ci sono.
                const sso = data && data.sso

                this.ssoProviders = (sso && sso.providers) || []
                this.ssoRequired = !!(sso && sso.required)
                this.ssoLoaded = true

                this.focalizzaEmail()
            },

            // I campi compaiono solo a configurazione SSO nota, quindi il
            // tentativo di focus in init() cade su un ref che ancora non
            // esiste: va rifatto qui, dopo che il render li ha creati. Se il
            // cliente non e' ancora stato indicato il focus resta dov'e',
            // altrimenti si toglierebbe da sotto le dita.
            mostraFormPassword() {
                this.forzaPassword = true
                this.focalizzaEmail()
            },

            focalizzaEmail() {
                if (!this.fqdn || !this.showPasswordForm) {
                    return
                }

                this.$nextTick(() => {
                    if (this.$refs.email) {
                        this.$refs.email.focus()
                    }
                })
            },

            caricaConfigurazioneSso() {
                if (this.ssoLoaded) {
                    // Gia' letta da getTenantInfo() in questo stesso
                    // caricamento: evita una seconda tenant-details identica.
                    return
                }

                this.axios.get('tenant-details').then(response => {
                    this.applicaConfigurazioneSso(response.data.data)
                }, () => {
                    // Se non riusciamo a leggerla, si mostra comunque il
                    // login classico: un problema di rete non deve chiudere
                    // fuori tutti quanti.
                    this.ssoLoaded = true
                })
            },

            iconaProvider(provider) {
                const icone = {
                    google: 'mdi-google',
                    microsoft: 'mdi-microsoft',
                }

                return icone[provider] || 'mdi-login'
            },

            avviaSso(provider) {
                // Si dichiara il dominio da cui si parte: il backend lo
                // convalida contro la lista dei domini ammessi e ci riporta
                // qui invece che sulla destinazione unica configurata. La SPA
                // vive su un sottodominio per tenant, quindi senza questo il
                // login cambierebbe dominio a meta' strada.
                this.axios.get('sso/' + provider + '/start', {
                    params: { origin: window.location.origin }
                }).then(response => {
                    if (response.data.url) {
                        window.location.href = response.data.url
                    }
                }, () => {
                    this.$store.commit('setSnackbar', {timeout: 6000, text: 'Impossibile avviare l\'accesso', value: true, color: 'error'})
                })
            },

            getTenantInfo() {
                if(this.fqdn != '') {
                    // La configurazione del tenant precedente non deve
                    // sopravvivere al cambio: finche' non risponde il nuovo
                    // tenant-details, mostrare il form password in base a quella
                    // vecchia significa mostrarlo anche dove l'SSO e' obbligatorio.
                    // Anche la scelta "Accedi con password" appartiene al tenant
                    // che si sta lasciando.
                    this.ssoLoaded = false
                    this.ssoRequired = false
                    this.ssoProviders = []
                    this.forzaPassword = false

                    localStorage.setItem('fqdn', this.fqdn)
                    this.$store.dispatch('SET_FQDN').then(() => {

                        this.axios({url: 'tenant-details', method: 'GET' })
                        .then(resp => {
                            if(resp.data.success) {
                                let data = resp.data.data
                                if(data.app_logo) {
                                    localStorage.app_logo = data.app_logo
                                } else {
                                    localStorage.removeItem('app_logo')
                                }
                                if(data.app_color) {
                                    localStorage.app_color = data.app_color
                                } else {
                                    localStorage.removeItem('app_color')
                                }

                                this.applicaConfigurazioneSso(data)

                            } else {
                                localStorage.removeItem('fqdn')
                                this.fqdn = ''
                                // Senza questo il form resterebbe nascosto dietro
                                // l'indicatore di caricamento: avendo azzerato
                                // ssoLoaded qui sopra, nessun altro lo rimette a
                                // posto sui percorsi che non arrivano a
                                // applicaConfigurazioneSso().
                                this.ssoLoaded = true
                            }
                            this.setLogo()
                        })
                        .catch(err => {
                            localStorage.removeItem('fqdn')
                            this.fqdn = ''
                            this.ssoLoaded = true
                            this.setLogo()
                        })
                    })
                }
            },

			getCopy() {
				let tempInput = document.createElement('input')
				tempInput.value = this.google2fa_secret
				document.body.appendChild(tempInput)
				tempInput.select()
				document.execCommand('copy')
				document.body.removeChild(tempInput)
				this.$store.commit('setSnackbar', {timeout: 6000, text: 'Copiato negli appunti!', value: true, color: 'success'})
			},            
        },

        mounted() {
            const url = new URL(window.location.href)
            const params = new URLSearchParams(url.search)

            let detectedFqdn = params.get('fqdn')

            // Se non c'è il query param, prova a ricavare il fqdn dal subdomain
            // (es. stiip.givemehive.cloud -> stiip). Esclude i subdomain riservati.
            if (!detectedFqdn) {
                const RESERVED = ['app', 'www', 'localhost']
                const match = window.location.hostname.match(/^([^.]+)\.givemehive\.cloud$/)
                if (match && !RESERVED.includes(match[1])) {
                    detectedFqdn = match[1]
                }
            }

            if (detectedFqdn) {
                this.fqdn = detectedFqdn
                this.fqdnShow = false
                this.getTenantInfo()
            } else {
                this.setLogo()
            }
        }

    }
</script>

<style scoped>
.staging-badge {
    position: fixed;
    top: 10px;
    right: 10px;
    font-weight: bold;
    z-index: 999;
}
</style>